"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable complexity */
const react_1 = __importStar(require("react"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const isArray_1 = __importDefault(require("lodash/isArray"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const kebabCase_1 = __importDefault(require("lodash/kebabCase"));
const HelperUtils_1 = require("utils/HelperUtils");
const Dropdown_1 = __importStar(require("components/design-system/dropdown/Dropdown"));
const Shimmer_1 = __importDefault(require("components/design-system/shimmer/Shimmer"));
const FloatingComponent_1 = __importDefault(require("components/objectives/compact-objective/fragments/FloatingComponent"));
const Badge_1 = __importDefault(require("components/shared/Badge"));
const Checkbox_1 = __importDefault(require("components/shared/Checkbox"));
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const TooltipContainer_1 = __importDefault(require("components/shared/Tooltips/TooltipContainer"));
const Context_1 = require("./Context");
const MenuItemsContent = ({ headers, setTableHeaders, fixedLeftCount, fixedRightCount, hideColumnIndexes, toggleHideColumn, vPosition }) => {
    const { open, setOpen } = (0, Dropdown_1.useDropdown)() || {};
    return (react_1.default.createElement(Dropdown_1.default.MenuItems, { position: "right", type: "absolute", vPosition: vPosition, setDialogOpen: () => setOpen && setOpen(!open), maxHeight: 320, useScrollClose: true }, headers?.map(({ name, hide }, index) => {
        // do not show option in a dropdown if it is a checkbox or empty string
        if (name == 'checkbox' || name == '')
            return react_1.default.createElement(react_1.default.Fragment, null);
        // do not show option in the dropdown if it is a sticky colum
        const allIndex = headers?.map((header, index) => index);
        if (fixedLeftCount && allIndex.slice(0, fixedLeftCount).includes(index))
            return react_1.default.createElement(react_1.default.Fragment, null);
        if (fixedRightCount && allIndex.slice(-fixedRightCount).includes(index))
            return react_1.default.createElement(react_1.default.Fragment, null);
        return (react_1.default.createElement(Dropdown_1.default.MenuItem, { key: index, dataCy: (0, kebabCase_1.default)(name) },
            react_1.default.createElement(Checkbox_1.default, { name: `cbx-hide-column-${index}`, id: `cbx-hide-column-$${index}`, checked: setTableHeaders ? !hide : !hideColumnIndexes?.includes(index), onChange: (e) => toggleHideColumn && toggleHideColumn(index, e), labelClass: "capitalize" }, (0, HelperUtils_1.getObjectiveLocale)(name))));
    })));
};
const DropdownHideColumn = ({ withHideColumn, customHideColumnIcon, ...rest }) => {
    const { open } = (0, Dropdown_1.useDropdown)() || {};
    const { size, iconName, fillColor } = customHideColumnIcon || {};
    return (react_1.default.createElement("div", { className: "relative" },
        react_1.default.createElement(Dropdown_1.default.Trigger, { dataCy: "trigger-table-hide-column" },
            react_1.default.createElement(SVGIcon_1.default, { size: size || 24, iconName: iconName || 'icon-keyboard_control', fillColor: fillColor || 'var(--n-500)' })),
        open && (react_1.default.createElement(FloatingComponent_1.default, null,
            react_1.default.createElement(MenuItemsContent, { withHideColumn: withHideColumn, ...rest })))));
};
const Table = react_1.default.memo((props) => {
    const { headers, setTableHeaders, headerCheckbox, fixedLeftCount = 0, fixedRightCount = 0, withHideColumn, customHideColumnIcon, children, customClass, customHeaderStickyContainerCN, customClassTypographyHeader, customClassHeader, useBorderTopBottom = true, useOverflowTable = true, fixedLeftGrow = true, showTable = true } = props;
    const [isLeftEnd, setIsLeftEnd] = (0, react_1.useState)(true);
    const [isRightEnd, setIsRightEnd] = (0, react_1.useState)(false);
    const [isShowTable, setIsShowTable] = (0, react_1.useState)(showTable);
    const [hideColumnIndexes, setHideColumnIndexes] = (0, react_1.useState)([]);
    const ref = (0, react_1.useRef)(null);
    const checkScrollPosition = () => {
        if (!ref.current)
            return;
        const scrollWidth = ref.current.scrollWidth;
        const scrollLeft = ref.current.scrollLeft;
        const width = ref.current.clientWidth;
        // detect if current scroll position reach the right end
        if (scrollLeft >= scrollWidth - width) {
            setIsRightEnd(true);
        }
        else if (scrollLeft == 0) {
            // detect if current scroll position is on the start / left end
            setIsLeftEnd(true);
        }
        else {
            setIsLeftEnd(false);
            setIsRightEnd(false);
        }
    };
    const checkHideColumn = () => {
        const tempArray = [];
        headers?.forEach((header, index) => {
            if (header.hide)
                tempArray.push(index);
        });
        setHideColumnIndexes(tempArray);
    };
    const toggleHideColumn = (index, e) => {
        if (setTableHeaders) {
            const newHeaders = [...headers];
            newHeaders[index].hide = !e.target.checked;
            setTableHeaders(newHeaders);
        }
        else {
            const newArray = [...hideColumnIndexes];
            const foundIndex = newArray.indexOf(index);
            if (foundIndex > -1) {
                newArray.splice(foundIndex, 1);
            }
            else {
                newArray.push(index);
            }
            setHideColumnIndexes(newArray);
        }
    };
    (0, react_1.useEffect)(() => {
        checkScrollPosition();
        checkHideColumn();
    }, []);
    const tableCN = (0, classnames_template_literals_1.default)(`
    relative
    ${customClass && customClass}
  `);
    const contextValue = {
        headers,
        setTableHeaders,
        fixedLeftCount,
        fixedRightCount,
        isLeftEnd,
        isRightEnd,
        hideColumnIndexes,
        headerCheckbox,
        toggleHideColumn,
        fixedLeftGrow
    };
    return (react_1.default.createElement(Context_1.TableContext.Provider, { value: contextValue },
        react_1.default.createElement("div", { className: tableCN },
            isShowTable && withHideColumn && (react_1.default.createElement("div", { className: `absolute z-[11] right-[0px] flex items-center w-[60px] ${customClassHeader ? customClassHeader : ' h-[36px] px-[16px]'}` },
                react_1.default.createElement(Dropdown_1.default, null,
                    react_1.default.createElement(DropdownHideColumn, { withHideColumn: withHideColumn, customHideColumnIcon: customHideColumnIcon, headers: headers, setTableHeaders: setTableHeaders, fixedLeftCount: fixedLeftCount, fixedRightCount: fixedRightCount, hideColumnIndexes: hideColumnIndexes, toggleHideColumn: toggleHideColumn })))),
            react_1.default.createElement("div", { className: `relative ${useBorderTopBottom
                    ? 'border-0 border-b-[1px] border-solid border-n-400 pb-[4px]'
                    : ''} ${useOverflowTable ? 'overflow-auto' : ''}`, onScroll: () => {
                    checkScrollPosition();
                }, ref: ref },
                headers && (react_1.default.createElement(Row, { isHeader: true, customStickyContainerCN: customHeaderStickyContainerCN, useBorderTopBottom: useBorderTopBottom, useRowHover: false }, headers?.map(({ name, sort, isHideTitleHeader, useHeaderMargin, grow, useMinHeight = true, badge, options, isAlwaysVisible, useHeaderPadding }, index) => {
                    return (react_1.default.createElement(HeaderColumn, { sort: sort, customClass: customClassHeader, customClassTypographyHeader: customClassTypographyHeader, key: index, useHeaderMargin: useHeaderMargin, grow: grow, useMinHeight: useMinHeight, badge: badge, options: options, isShowTable: isShowTable, setIsShowTable: setIsShowTable, isAlwaysVisible: isAlwaysVisible, useHeaderPadding: useHeaderPadding, dataCy: `table-header-column-${index}` }, isHideTitleHeader ? '' : (0, HelperUtils_1.getObjectiveLocale)(name)));
                }))),
                isShowTable && children))));
});
function useTable() {
    return react_1.default.useContext(Context_1.TableContext);
}
const Row = react_1.default.memo(({ isHeader = false, onClick, customClass, children, useRowHover = true, useBorderTopBottom, customStickyContainerCN, onContextMenu, disabled = false, tooltip, dataCy = '' }) => {
    const { headers, setTableHeaders, fixedLeftCount, fixedRightCount, isLeftEnd, isRightEnd, hideColumnIndexes, fixedLeftGrow } = useTable() || {};
    // add width props to column (children)
    const childrensArray = [];
    children = Array.isArray(children) ? children : [children];
    children?.length > 0 &&
        children?.map((child) => {
            if ((0, isArray_1.default)(child)) {
                child.map((ch) => {
                    childrensArray.push(ch);
                });
            }
            else {
                typeof child !== 'boolean' && childrensArray.push(child);
            }
        });
    const modifiedChildren = childrensArray
        .filter((val) => val)
        ?.map((child, index) => {
        if (react_1.default.isValidElement(child)) {
            // get class and grow props from widthClasses Array
            let widthClass = '';
            let grow = false;
            let customClass = '';
            let heightClass = '';
            // check and send props hide
            const hide = setTableHeaders
                ? headers?.[index]?.hide
                : hideColumnIndexes?.includes(index);
            widthClass = headers?.[index]?.widthClass || '';
            heightClass = headers?.[index]?.heightClass || '';
            grow = !!headers?.[index]?.grow;
            customClass = `${child.props?.customClass} ${headers?.[index]?.customClass}`;
            return react_1.default.cloneElement(child, {
                widthClass: widthClass,
                grow: grow,
                hide: hide,
                customClass: customClass,
                heightClass: heightClass
            });
        }
        return child;
    });
    let fixedLeftChildrens, fixedRightChildrens = [];
    if (fixedLeftCount && fixedLeftCount > 0) {
        fixedLeftChildrens = modifiedChildren.splice(0, fixedLeftCount);
    }
    if (fixedRightCount && fixedRightCount > 0) {
        fixedRightChildrens = modifiedChildren.splice(-fixedRightCount);
    }
    const rowCN = (0, classnames_template_literals_1.default)(`
    relative flex min-w-full w-max
    ${useRowHover && 'group'}
    ${isHeader && useBorderTopBottom
        ? 'border-0 border-b-[1px] border-solid border-n-400 z-[1] mb-[4px]'
        : useRowHover && 'hover:bg-base-3008'}
    ${onClick && 'cursor-pointer'}
    ${disabled && 'opacity-30'}
    ${customClass && customClass}
  `);
    const stickyContainerCN = (position) => (0, classnames_template_literals_1.default)(`
    flex sticky flex-shrink-0 bg-n-000
    ${customStickyContainerCN && customStickyContainerCN}
    ${position == 'left'
        ? `left-[0px] ${fixedLeftGrow ? 'grow' : ''}`
        : 'right-[0px]'}
    ${position == 'left' && !isLeftEnd && 'shadow-right'}
    ${position == 'right' && !isRightEnd && 'shadow-left'}
  `);
    // Since sticky  behave like a row
    // I assume custom class for row shoul be applied to sticky container
    const stickyContentCN = (0, classnames_template_literals_1.default)(`
    flex
    ${fixedLeftGrow ? 'grow' : ''}
    ${customClass && customClass.replace('mt-[-1px]', ' ')}
    ${!isHeader && useRowHover && 'group-hover:bg-base-3008'}
  `);
    return (react_1.default.createElement(TooltipContainer_1.default, { show: tooltip?.show || false, text: tooltip?.text || '', useMaxWidth: false },
        react_1.default.createElement("div", { className: rowCN, onClick: onClick, onContextMenu: onContextMenu, "data-cy": dataCy },
            fixedLeftCount != undefined && fixedLeftCount > 0 && (react_1.default.createElement("div", { className: stickyContainerCN('left') },
                react_1.default.createElement("div", { className: stickyContentCN }, fixedLeftChildrens))),
            modifiedChildren,
            fixedRightCount != undefined && fixedRightCount > 0 && (react_1.default.createElement("div", { className: stickyContainerCN('right') },
                react_1.default.createElement("div", { className: stickyContentCN }, fixedRightChildrens))))));
});
const Column = react_1.default.memo(({ widthClass, grow, children, hide, customClass, noPadding = false, dataCy, isClickable = true, style, heightClass }) => {
    const columnCN = (0, classnames_template_literals_1.default)(`
    ${widthClass}
    ${heightClass ? heightClass : 'h-[56px]'}
    flex items-center flex-shrink-0
    ${!noPadding && 'px-[16px]'}
    ${grow && 'grow'}
    ${hide && 'hidden'}
    ${customClass}
    ${!isClickable && 'pointer-events-none'}
  `);
    return (react_1.default.createElement("div", { className: columnCN, "data-cy": dataCy, style: style }, children));
});
const HeaderColumn = ({ widthClass, grow, children, hide, customClass, sort, customClassTypographyHeader, useHeaderMargin = true, useMinHeight = true, badge, options, isShowTable, setIsShowTable, isAlwaysVisible, useHeaderPadding = true, dataCy }) => {
    const [sortDirection, setSortDirection] = (0, react_1.useState)(sort?.default || 'asc');
    const onClickHeader = () => {
        setSortDirection(sortDirection == 'asc' ? 'desc' : 'asc');
        sort && sort.onSort(sortDirection == 'asc' ? 'desc' : 'asc');
    };
    const columnCN = (0, classnames_template_literals_1.default)(`
    ${widthClass}
    flex items-center flex-shrink-0
    ${useHeaderPadding && 'px-[16px]'}
    ${useMinHeight && 'min-h-[36px]'}
    ${grow && 'grow'}
    ${hide && 'hidden'}
    ${sort && 'cursor-pointer'}
    ${options && 'group'}
    ${customClass}
    `);
    const { headerCheckbox } = useTable() || {};
    return (react_1.default.createElement("div", { className: columnCN, onClick: onClickHeader, "data-cy": dataCy },
        react_1.default.createElement("div", { className: `${useHeaderMargin ? 'mr-[8px]' : ''} ${customClassTypographyHeader
                ? customClassTypographyHeader
                : 'typography-h300 text-n-800'} ${!(0, isEmpty_1.default)(badge) && children !== ''
                ? 'flex items-center ml-[-16px]'
                : ''}
          ${isShowTable ? '' : `${isAlwaysVisible ? '' : 'invisible'}`}
        ` },
            !(0, isEmpty_1.default)(badge) && (react_1.default.createElement(Badge_1.default, { content: badge?.content, colorHex: badge?.colorHex, bgColorHex: badge?.bgColorHex, className: `cursor-pointer ${children !== '' && 'mr-[8px]'}`, onClick: () => setIsShowTable && setIsShowTable(!isShowTable), useEvent: true, dataCy: `table-header-badge-${(0, kebabCase_1.default)(badge?.content)}` })),
            children == 'checkbox' ? (react_1.default.createElement(Checkbox_1.default, { name: "header-cbx", id: "header-cbx", dataCy: "header-cbx", checked: !!headerCheckbox?.checked, onClick: headerCheckbox?.onClick, disabled: headerCheckbox?.disabled || false })) : children == 'arrow-icon' ? (react_1.default.createElement(SVGIcon_1.default, { size: 24, iconName: isShowTable
                    ? 'icon-keyboard_arrow_down'
                    : 'icon-keyboard_arrow_right', fillColor: "var(--n-600)", customClass: "cursor-pointer", onClick: () => setIsShowTable && setIsShowTable(!isShowTable) })) : (children)),
        options && (react_1.default.createElement(Dropdown_1.default, null,
            react_1.default.createElement("div", { className: "hidden group-hover:flex ml-[8px]" },
                react_1.default.createElement(Dropdown_1.default.Trigger, null,
                    react_1.default.createElement(SVGIcon_1.default, { size: 24, fillColor: "var(--n-600)", iconName: "icon-keyboard_control" }))),
            react_1.default.createElement(Dropdown_1.default.MenuItems, { customClass: "w-[220px]", options: options, type: "fixed" }))),
        sort && (react_1.default.createElement(SVGIcon_1.default, { size: 16, iconName: sortDirection == 'asc'
                ? 'icon-sort-ascending'
                : 'icon-sort-descending', fillColor: "var(--n-500)", customClass: "transition-transform duration-[50ms]" }))));
};
const LoadingRow = () => {
    const { headers } = useTable() || {};
    if (!headers)
        return null;
    return (react_1.default.createElement(Row, null, headers.map((_, index) => {
        return (react_1.default.createElement(Column, { key: index },
            react_1.default.createElement(Shimmer_1.default, { height: "20px", widthRandomness: 0.25, circle: true })));
    })));
};
Table.displayName = 'Table';
Row.displayName = 'Row';
Column.displayName = 'Column';
LoadingRow.displayName = 'LoadingRow';
const TableWithStatics = Object.assign({}, Table, {
    Row: Row,
    LoadingRow: LoadingRow,
    Column: Column,
    HeaderColumn: HeaderColumn
});
exports.default = TableWithStatics;
